export const DEFAULT_FEATURE_FLAGS = {
  ENABLE_WORD_TIMING_REPAIR: false,
};

function envFlag(name) {
  if (typeof process === 'undefined' || !process?.env) return undefined;
  return process.env[name];
}

function isTruthyFlag(value) {
  return /^(1|true|yes|on)$/i.test(String(value || '').trim());
}

export function isWordTimingRepairEnabled(opts = {}) {
  if (opts.enableWordTimingRepair === true) return true;
  if (opts.enableWordTimingRepair === false) return false;

  const value = envFlag('REACT_APP_ENABLE_WORD_TIMING_REPAIR')
    ?? envFlag('ENABLE_WORD_TIMING_REPAIR');
  if (value != null) return isTruthyFlag(value);

  return DEFAULT_FEATURE_FLAGS.ENABLE_WORD_TIMING_REPAIR;
}
